import {LoadError} from '@app/core/store/actions/error.actions';

export interface IErrorState {
	loadError: LoadError;
}

export const initialErrorState: IErrorState = {
	loadError: undefined,
};
